<template>
    <div class="row mt-3">
        <div class="col-xs-12 text-center">
            <v-checkbox
                :label="$t('PRO_EXTERNAL_DOCUMENTATION')"
                v-model="examinationData.pro_external_documentation"
                hide-details
                color="main-color"
            >
            </v-checkbox>

            <button
                @click.stop="sendExaminationData"
                class="w160 app-btn app-btn--small app-btn-primary"
                :disabled="!examinationData.pro_external_documentation"
            >
                {{ $t('CLOSE') }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: ['examinationId'],
    data() {
        return {
            examinationData: {
                id: this.examinationId,
                pro_external_documentation: false,
            },
        };
    },
    methods: {
        sendExaminationData() {
            this.$http
                .post(
                    '/examination/api/result/' + this.examinationData.id + '/fillPatientProData/',
                    this.examinationData,
                )
                .then(() => this.closeForm());
        },
        closeForm() {
            this.$emit('hideForm');
            this.$emit('reloadExaminations');
        },
    },
};
</script>

<style lang="scss" scoped>
button:disabled {
    opacity: 0.6;

    &:hover {
        background-color: #cf004a;
        color: #fff;
        border-color: #cf004a;
    }
}
</style>



// WEBPACK FOOTER //
// external-documentation-data-form.vue?1bfa59a0